// ContractAndPricingForm.js

import React from 'react';
import ContractForm from './Add_Contract_Details.js';
import PricingForm from './Add_Pricing.js';
import {Link} from 'react-router-dom';

const ContractAndPricingForm = () => {
  return (
      <ContractForm />
  );
};

export default ContractAndPricingForm;
